var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupMenuDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21513_1415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.15238 2.29677L10.3256 4.66257C10.4856 4.9919 10.9122 5.30778 11.2722 5.36827L13.3986 5.72448C14.7585 5.953 15.0784 6.94772 14.0985 7.92898L12.4454 9.59578C12.1654 9.87805 12.0121 10.4224 12.0987 10.8123L12.5721 12.8757C12.9453 14.5089 12.0854 15.1407 10.6522 14.287L8.65912 13.0975C8.29918 12.8824 7.70592 12.8824 7.33925 13.0975L5.34616 14.287C3.91965 15.1407 3.05308 14.5021 3.42638 12.8757L3.89966 10.8123C3.98631 10.4224 3.833 9.87805 3.55302 9.59578L1.89988 7.92898C0.926651 6.94772 1.23995 5.953 2.5998 5.72448L4.72623 5.36827C5.07952 5.30778 5.50614 4.9919 5.66612 4.66257L6.83932 2.29677C7.47925 1.01306 8.51912 1.01306 9.15238 2.29677Z",
    stroke: "#616161"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21513_1415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupMenuDefault);
export default __webpack_public_path__ + "static/media/group_menu_default.9bb43f71de017c7861f52d9db7f87d87.svg";
export { ForwardRef as ReactComponent };